module.exports={
    logout  : "계 정 을 말소 하 다",
    my      :'나의',
    scqx    :'삭제 권한',
    qxgl    :'권한 관리',
    qdzxzhm :'계 정 로그아웃 하 시 겠 습 니까?',
    qtxkh   :'카드번호 적어 주세요.',
    qd      :'확정 하 다.',
    qx      :'취소 하 다.',
    gb      :'닫다',
    kh      :'카드번호',
    kmewm   :'오픈 QR 코드',
    dl      :'로그 인',
    name    :'사용자 이름',
    qtxname :'아 이 디 를 적어 주세요.',
    pwas    :'비밀 번호',
    qtxpwas :'비밀 번 호 를 입력 해 주세요.',
    tj      :'제출 하 다.',
    zczh    :'계 정 등록',
    zc      :'책.',
    sjhm    :'핸드폰 번호',
    qtxsjhm :'핸드폰 번호 적어 주세요.',
    yzm     :'인증번호',
    qtxyzm  :'인증번호 써 주세요.',
    yyzhqqdl:'계 정 이 있 으 니 로그 인 하 세 요.',
    hqyzm   :'인증번호 가 져 오기',
    zccg    :'등록 완료',
    zcsb    :'등록 실패',
    fscg    :'발송 성공',
    fssb    :'발송 실패',
    yhycz   :'사용자 가 이미 존재 합 니 다'
}